module.exports = __webpack_public_path__ + "static/media/F1_DIFF.5f3a198b.png";